var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname && links[i].hostname.indexOf("livonlabs") === -1 && links[i].hostname.indexOf("livonresellers") === -1) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


/*
document.querySelector('button.jvlfree').addEventListener('click', function(event) {
  var jvliteminfo;
  var jvlincart = 0;
  console.log(jvlincart);
  var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { 
     for (i = 0; i < data.items.length; i++) {
       jvliteminfo = data.items[i].handle;
       var jvlresult = jvliteminfo.includes("-free");
       if (jvlresult === true) {
         var jvlincart = 1;

let updates = {47302122996000: 1};
fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
       }
       console.log(jvlincart);
     }
   });
});
*/